// frontend/src/components/settings/NotificationSettings.tsx

import { useState } from 'react';
import { settingsService } from '../../services/settings.service';
import { NotificationPreferences } from '../../types/auth.types';

const LABELS: { key: keyof NotificationPreferences; title: string; desc: string }[] = [
  { key: 'daily_reminder', title: 'Günlük Hatırlatma', desc: 'Her gün çalışma hatırlatması' },
  { key: 'new_lesson_alert', title: 'Yeni Ders Bildirimi', desc: 'Yeni ders eklendiğinde bildir' },
  { key: 'ai_mentor_messages', title: 'AI Mentor Mesajları', desc: 'AI mentor önerileri' },
];

interface NotificationSettingsProps {
  userId: string;
  preferences: NotificationPreferences;
}

export function NotificationSettings({ userId, preferences }: NotificationSettingsProps) {
  const [prefs, setPrefs] = useState(preferences);

  async function handleToggle(key: keyof NotificationPreferences) {
    const updated = { ...prefs, [key]: !prefs[key] };
    setPrefs(updated);
    try {
      await settingsService.updateNotificationPreferences(userId, updated);
    } catch {
      setPrefs(prefs); // başarısız olursa eski haline döndür
    }
  }

  return (
    <div className="card">
      <h3 className="parent-section-title">Bildirimler</h3>
      <div className="notification-list">
        {LABELS.map((item) => (
          <div className="notification-row" key={item.key}>
            <div>
              <div className="notification-title">{item.title}</div>
              <div className="notification-desc">{item.desc}</div>
            </div>
            <button
              type="button"
              className={`toggle-switch ${prefs[item.key] ? 'on' : ''}`}
              onClick={() => handleToggle(item.key)}
              aria-pressed={prefs[item.key]}
              aria-label={item.title}
            >
              <span className="toggle-knob" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
